import { MaterialModule } from '../material.module';
import { AlertComponent } from './components/alert-label/alert.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ErrorCodeComponent } from './components/error-code/error-code.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { IfRolesDirective } from './directives/if-role.directive';
import { ObjectOrStringPipe } from './pipes/object-or-string.pipe';
// import { NgrxMatSelectViewAdapterDirective } from './directives/ngrx-mat-select-view-adapter';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { ToObservablePipe } from './pipes/to-observable.pipe';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgrxFormsModule } from 'ngrx-forms';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { ToastrModule } from 'ngx-toastr';
import { UserDialogComponent } from './components/user-dialog/user-dialog.component';

const MODULES = [
  MaterialModule,
  FlexLayoutModule,
  NgProgressModule,
  NgProgressRouterModule,
  NgProgressHttpModule,
  NgSelectModule,
  NgrxFormsModule,
  ToastrModule,
  TranslateModule,
];
const COMPONENTS = [
  BreadcrumbComponent,
  PageHeaderComponent,
  ErrorCodeComponent,
  AlertComponent,
  UserDialogComponent
];
const COMPONENTS_DYNAMIC = [];
const DIRECTIVES = [IfRolesDirective];
const PIPES = [SafeUrlPipe, ToObservablePipe, ObjectOrStringPipe];

@NgModule({
  declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC, ...DIRECTIVES, ...PIPES],
  imports: [CommonModule, FormsModule, RouterModule, ReactiveFormsModule, ...MODULES],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    UserDialogComponent,
    ...MODULES,
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
  ],
})
export class SharedModule {}
